import type { DocPageContent } from '../types';

/**
 * "Proactive nudges" — Dashboard section (ADR-0074).
 * Reconciled from apps/web `features/engagement/nudges` — the Nudges tab of
 * `/engagement` (ADR-0538 merged `/proactive` into it) — and the
 * `proactive.*` catalog. The page leads with the limits rather than the
 * capability: an operator reading about a feature that opens chat on its own
 * needs to know what stops it becoming spam before they need to know how to
 * write one.
 */
export const DASHBOARD_PROACTIVE_PAGE: DocPageContent = {
  slug: 'dashboard/proactive',
  titleKey: 'docs.dashboard.proactive.title',
  descriptionKey: 'docs.dashboard.proactive.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.proactive.lead' },

    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.dashboard.proactive.off.title',
      textKey: 'docs.dashboard.proactive.off.body',
    },

    { kind: 'heading', level: 2, id: 'rule', textKey: 'docs.dashboard.proactive.rule.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.proactive.rule.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.dashboard.proactive.rule.trigger.term',
          descKey: 'docs.dashboard.proactive.rule.trigger.desc',
        },
        {
          termKey: 'docs.dashboard.proactive.rule.audience.term',
          descKey: 'docs.dashboard.proactive.rule.audience.desc',
        },
        {
          termKey: 'docs.dashboard.proactive.rule.message.term',
          descKey: 'docs.dashboard.proactive.rule.message.desc',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'limits', textKey: 'docs.dashboard.proactive.limits.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.proactive.limits.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.proactive.limits.item.once',
        'docs.dashboard.proactive.limits.item.quiet',
        'docs.dashboard.proactive.limits.item.dismiss',
        'docs.dashboard.proactive.limits.item.busy',
        'docs.dashboard.proactive.limits.item.open',
      ],
    },

    { kind: 'heading', level: 2, id: 'saving', textKey: 'docs.dashboard.proactive.saving.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.proactive.saving.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.proactive.next.starters.title',
          textKey: 'docs.dashboard.proactive.next.starters.text',
          to: { docSlug: 'dashboard/starters' },
        },
        {
          titleKey: 'docs.dashboard.proactive.next.rules.title',
          textKey: 'docs.dashboard.proactive.next.rules.text',
          to: { docSlug: 'dashboard/page-rules' },
        },
      ],
    },
  ],
};
